/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import { csoCustomerOrder, orderManagement } from '@/api/ajax';
import { taxCollectionPatternMap } from '@/config/staticData';
import { bankSearchFiled, payTypeSearchFiled } from '@/common/fields/bank'; // 在这混入兼容方便兼容之前数据
import { PAY_STATUS } from '@/common/constants/order';

const taxCollectionPatternMap2Arr = () => {
  const arr = [];
  for (let key in taxCollectionPatternMap) {
    arr.push({ name: taxCollectionPatternMap[key], key });
  }
  return arr;
};

export default [
  {
    width: 140,
    id: 'createDate',
    label: '提交日期',
    required: false,
    slot: 'daterange',
    format: 'yyyy-MM-dd',
    key: 'createDate',
    text: ['提交日期起', '提交日期止']
    // key: ['createDateStart', 'createDateEnd']
  },
  {
    width: 140,
    id: 'submitDt',
    label: '结算日期',
    required: false,
    slot: 'daterange',
    format: 'yyyy-MM-dd',
    // key: 'createDate',
    text: ['结算日期起', '结算日期止'],
    key: ['submitStartDate', 'submitEndDate']
  },
  {
    width: 180,
    tip: '订单编号',
    label: '订单编号',
    key: 'orderNumber',
    id: 'orderNumber',
    slot: 'input'
  },
  {
    width: 180,
    tip: '结算单号',
    label: '结算单号',
    key: 'industryFenpeiCode',
    id: 'industryFenpeiCode',
    slot: 'input'
  },
  {
    width: 180,
    tip: '订单生成时间',
    label: '订单生成时间',
    key: 'paymentDeadline',
    id: 'paymentDeadline',
    format: 'yyyy-MM',
    slot: 'monthrange'
  },
  {
    width: 180,
    tip: '支付截止时间',
    label: '支付截止时间',
    key: 'paymentDeadline',
    id: 'paymentDeadline',
    slot: 'monthrange'
  },
  {
    width: 180,
    id: 'zhifuzhuangtai',
    key: 'payStatus',
    tip: '支付状态',
    label: '支付状态',
    required: false,
    slot: 'select',
    clearable: true,
    options: [
      { name: '未支付', key: 0 },
      { name: '支付中', key: 1 },
      { name: '支付成功', key: 2 },
      { name: '支付失败', key: 3 }
    ]
  },
  {
    width: 180,
    id: 'payStatus',
    key: 'payStatus',
    tip: '支付状态',
    label: '支付状态',
    required: false,
    slot: 'select',
    clearable: true,
    options: [
      { name: '已完成', key: 1 },
      { name: '未完成', key: 0 }
    ]
  },
  {
    width: 180,
    id: 'fufuweizhuangtai',
    key: 'servicesStatus',
    tip: '平台服务费状态',
    label: '平台服务费状态',
    required: false,
    slot: 'select',
    clearable: true,
    options: [
      { name: '未支付', key: 0 },
      { name: '支付中', key: 1 },
      { name: '支付成功', key: 2 },
      { name: '支付失败', key: 3 }
    ]
  },
  {
    width: 180,
    id: 'bussniessServicesStatus',
    key: 'bussniessServicesStatus',
    tip: '商务服务费状态',
    label: '商务服务费状态',
    required: false,
    slot: 'select',
    clearable: true,
    options: [
      { name: '未支付', key: 0 },
      { name: '支付中', key: 1 },
      { name: '支付成功', key: 2 },
      { name: '支付失败', key: 3 }
    ]
  },
  // 项目搜索
  {
    id: 'projectNameAndId',
    key: 'projectId',
    tip: '项目名称',
    label: '项目名称',
    required: false,
    slot: 'ajaxSelect',
    ajax: async data => {
      try {
        const res = await orderManagement.getSelectProjectList(data);
        return res;
      } catch (error) {
        return error;
      }
    },
    prop: {
      label: 'projectName',
      code: 'projectId'
    },
    ajaxQuery: 'projectName',
    width: 'auto'
  },
  // 结算单 创建
  {
    id: 'xiangmumingcheng',
    key: 'projectId',
    tip: '项目名称',
    label: '项目名称',
    required: false,
    slot: 'ajaxSelectEmpty',
    ajax: csoCustomerOrder.listAllProjectForSelect,
    prop: {
      label: 'projectName',
      code: 'project_id'
    },
    ajaxQuery: 'projectName',
    // multiple:true,
    width: 'auto'
  },
  {
    id: 'jiesuangongyingshang',
    key: 'supplierId',
    tip: '供应商',
    label: '供应商',
    required: false,
    slot: 'ajaxSelect',
    ajax: orderManagement.getSelectSupplierList,
    prop: {
      label: 'supplierName',
      code: 'supplierId'
    },
    ajaxQuery: 'supplierName',
    width: 'auto'
  },
  {
    id: 'renwuyuedu',
    key: 'taskDt',
    tip: '提交日期',
    label: '提交日期',
    required: false,
    format: 'yyyy-MM',
    slot: 'date',
    val: '',
    defaultValue: function() {
      return new Date();
    }
  },
  {
    id: 'xiangmucanyuren',
    key: 'fullName',
    tip: '项目参与人',
    label: '项目参与人',
    required: false,
    slot: 'input'
  },
  {
    id: 'operator',
    key: 'fullName',
    tip: '经营者',
    label: '经营者',
    required: false,
    slot: 'input'
  },
  {
    id: 'industryId',
    key: 'industryEnterpriseName',
    tip: '工业',
    label: '工业',
    required: false,
    slot: 'input'
  },
  {
    id: 'shoujihao',
    key: 'phone',
    tip: '手机号',
    label: '手机号',
    required: false,
    slot: 'input'
  },
  // 生成订单中的多个月度选择
  {
    id: 'createTaskDt',
    key: '_taskDts',
    tip: '任务月度',
    label: '任务月度',
    required: false,
    slot: 'ajaxSelectEmpty',
    ajax: csoCustomerOrder.listAllTaskDtForSelect,
    prop: {
      label: 'task_dt',
      code: 'task_dt'
    },
    query: {
      operateType: 1
    },
    ajaxQuery: 'projectName',
    width: 'auto'
  },
  // 生成订单中的多个项目名选择
  {
    id: 'createProjectId',
    key: '_projectIds',
    tip: '项目名称',
    label: '项目名称',
    required: false,
    slot: 'ajaxSelectEmpty',
    ajax: async data => {
      try {
        const res = await orderManagement.getSelectProjectListV2(data);
        return res;
      } catch (error) {
        return error;
      }
    },
    prop: {
      label: 'projectName',
      code: 'projectId'
    },
    query: {},
    ajaxQuery: 'projectName',
    // multiple:true,
    width: 'auto'
  },
  {
    id: 'taxCollectionPattern',
    key: 'taxCollectionPattern',
    width: 180,
    tip: '交易结构',
    label: '交易结构',
    required: false,
    slot: 'select',
    clearable: true,
    options: taxCollectionPatternMap2Arr()
  },
  bankSearchFiled,
  payTypeSearchFiled,
  {
    id: 'payStatusCascader',
    tip: '支付状态',
    label: '支付状态',
    key: ['payStatus', 'payFinishStatus'],
    attrs: {
      placeholder: '支付状态',
      clearable: true,
      props: {
        checkStrictly: true
      },
      options: Object.values(PAY_STATUS)
    },
    slot: 'cascader'
  }
];
